export default "__VITE_ASSET__QDUeXXRU__"